import { awsConsumerClient, INextError, LoggerInstance } from '@vfit/shared/data-access';
import { API, errorMock } from '@vfit/shared/data-access';
import { useMutation, useQueryClient } from 'react-query';
import { retrieveUserAgent } from '@vfit/consumer/data-access';
import { retrieveRegisterPayload } from './device.utils';
import { IRegisterDevicePayload, IRegisterDeviceResponse } from './device.models';

const registerDevice = (payload: IRegisterDevicePayload) =>
  awsConsumerClient.post(`${API.DXL_REGISTER_DEVICE}`, payload, {
    headers: {
      'Content-Type': 'application/json',
      'x-device-useragent': retrieveUserAgent(),
    },
  });

export const useRegisterDevice = () => {
  const queryClient = useQueryClient();
  const payload = retrieveRegisterPayload();
  return useMutation('registerDevice', () => registerDevice(payload), {
    onSuccess: (data: IRegisterDeviceResponse) => {
      queryClient.setQueryData('registerDevice', data);
    },
    onError: (error: INextError) => {
      LoggerInstance.error('ERROR - registerDevice', error);
      queryClient.setQueryData('registerDevice', errorMock('registerDevice'));
    },
  });
};
